module.exports = __webpack_public_path__ + "img/img24.cca91863.jpg";